import { Assignment, BackHand, DisplaySettings, Info, Inventory, Photo, Science, Fireplace, Error } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Context from "../../../../context/Context";
import Pendency from "../Pendency";
import GSAModal from "../GSAModal";
import language from '../../../../nls/language.json';
import { Button } from "@mui/base";
import './styles.css'
import { getCookie } from "../../../../section/cookie";
export default function ButtonsSectorPieces({ code, setIdScreen, handleTitle }) {
    const {
        setIdStep,
        getPartFlow,
        handleInfo,
        getBuffers,
        getMaterialForm,
        getSalesOrdersBI,
        setShowmodalIMG,
        setToolTipText,
        setShowModalFicha,
        selectedCountry,
        getSimilarParts,
        getFornosHitorico
    } = useContext(Context);
    const iconScaleSectorPieces = 1.2;

    const cookie = getCookie("permissions")
    const gsaClaim = cookie.includes("[GSA] - Apontar pecas")

    useEffect(() => {
        handleFicha(92, code)
    }, [])

    const handleFicha = async (id, data) => {
        // O idStep é definido ANTES do fetch para o spinner aparecer já na aba
        // alvo; o guard de sequência no Context descarta respostas obsoletas.
        switch (id) {
            case 91:
                setIdStep(1);
                await getPartFlow(data);
                break;
            case 92:
                setIdStep(2);
                await handleInfo(data);
                break;
            case 93:
                setIdStep(3);
                await getBuffers(data);
                break;
            case 94:
                setIdStep(4);
                await getMaterialForm(data);
                break;
            case 95:
                setIdStep(5);
                await getSalesOrdersBI(data);
                break;
            case 96:
                setShowmodalIMG(data);
                break;
            case 97:
                setToolTipText((
                    <Pendency
                        data={data}
                        setIdScreenFicha={setIdScreen}
                    />
                ));
                setIdStep(7);
                setShowModalFicha(true)
                break;
            case 99:
                setIdStep(9);
                await getFornosHitorico(data);
                break;
            case 100:
                setToolTipText((
                    <GSAModal
                        data={data}
                        setIdScreenFicha={setIdScreen}
                    />
                ));
                setShowModalFicha(true)
                setIdStep(10);
                break;
        }
    }

    return (
        <Tabs
            defaultActiveKey={92}
            id="fill-tab-example"
            className="tab-ButtonsSectorPieces"
            onSelect={(e) => handleFicha(Number(e), code)}
        >
            <Tab
                eventKey={91}
                title={handleTitle(<DisplaySettings sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: 'white',
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.fluxo)}
            />
            <Tab
                eventKey={92}
                title={handleTitle(<Info sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: '#999999'
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.info)}
            />
            <Tab
                eventKey={93}
                title={handleTitle(<Inventory sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.racks)}
            />
            <Tab
                eventKey={94}
                title={handleTitle(<Science sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: '#31e658'
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.formula)}
            />
            <Tab
                eventKey={95}
                title={handleTitle(<Assignment sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: "#744700"
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pedido)}
            />
            <Tab
                eventKey={96}
                title={handleTitle(<Photo color="secondary" sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.imagem)}
            />
            <Tab
                eventKey={97}
                title={handleTitle(<BackHand color="error" sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pendencia)}
            />

            {/* <Tab
                eventKey={98}
                title={handleTitle(<Science sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pecasSemelhantes)}
            /> */}

            <Tab
                eventKey={99}
                title={handleTitle(<Fireplace sx={{ transform: `scale(${iconScaleSectorPieces})` }} />, "Forno")}
            />

            {gsaClaim && (<Tab
                eventKey={100}
                title={handleTitle(<Error color="warning" sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.gsa)}
            />)}

        </Tabs>
    )
}
